import script from "./ContentHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentHeader.vue?vue&type=script&setup=true&lang=js"

import "./ContentHeader.vue?vue&type=style&index=0&id=4e2f1133&lang=scss"

const __exports__ = script;

export default __exports__